var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-alt-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 16.4583C2.5 17.0333 2.96667 17.5 3.54167 17.5H16.4583C17.0333 17.5 17.5 17.0333 17.5 16.4583V8.6958L10.725 2.12497C10.3208 1.72914 9.67917 1.72914 9.275 2.12497L2.5 8.6958V16.4583ZM16.25 9.2208V16.25H3.75V9.22497L10 3.16247L16.25 9.2208ZM6.25 14.5833V13.3333H13.75V14.5833H6.25Z",
    fill: "#0D181D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAlt);
export default __webpack_public_path__ + "static/media/home-alt.46a0ff9094cd6803ec4b098027d4a0dd.svg";
export { ForwardRef as ReactComponent };